import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { decode } from "base-64";
export const follow_unfollow = (tokens, action, profileID, redirectURL) => {
  var fd = new FormData();
  fd.append("token", decode(tokens));
  fd.append("identity", "wmhandler");
  fd.append("profile_id", decode(profileID));
  fd.append("action", decode(action));
  axios({
    method: "POST",
    url: `${API_ENDPOINT.apiURL}Profile/followFollowing`,
    data: fd,
  })
    .then(function (response) {
      console.log("redirected Follow", response);
      window.location.assign(`/${decode(redirectURL)}`);
    })
    .catch(function (err) {
      console.log(err.message);
      window.location.assign(`${API_ENDPOINT.redirectURL}/${decode(redirectURL)}`);
    });
};
export const like_unlike = (tokens, action, metaID, metaPost, redirectURL) => {
  var fd = new FormData();
  fd.append("token", decode(tokens));
  fd.append("identity", "wmhandler");
  fd.append("post_type", decode(metaPost));
  fd.append("post_id", decode(metaID));
  fd.append("action", decode(action));
  axios({
    method: "POST",
    url: `${API_ENDPOINT.apiURL}Profile/reactOnPost`,
    data: fd,
  })
    .then(function (response) {
      console.log("Reaction Redirected", response);
      window.location.assign(`${API_ENDPOINT.redirectURL}${decode(redirectURL)}`);
    })
    .catch(function (err) {
      console.log(err.message);
      window.location.assign(`${API_ENDPOINT.redirectURL}${decode(redirectURL)}`);
    });
};

export const postMainCommentOnBlog = (
  tokens,
  action,
  metaID,
  metaPost,
  redirectURL,
  metaContent
) => {
  console.log(tokens, action, metaID, metaPost, redirectURL, metaContent);
  var fd = new FormData();
  fd.append("token", decode(tokens));
  fd.append("identity", "wmhandler");
  fd.append("postType", decode(metaPost));
  fd.append("postId", decode(metaID));
  fd.append("content", decode(metaContent));
  axios({
    method: "POST",
    url: `${API_ENDPOINT.apiURL}Profile/postComments`,
    data: fd,
  })
    .then(function (response) {
      window.location.assign(`${API_ENDPOINT.redirectURL}${decode(redirectURL)}`);
    })
    .catch(function (err) {
      console.log(err);
    });
};
export const postMainChildCommentOnBlog = (
  tokens,
  action,
  metaID,
  metaPost,
  redirectURL,
  metaContent,
  metaParentID
) => {
//   console.log(tokens, action, metaID, metaPost, redirectURL, metaContent);
  var fd = new FormData();
  fd.append("token", decode(tokens));
  fd.append("identity", "wmhandler");
  fd.append("postType", "blog");
  fd.append("postId", decode(metaID));
  fd.append("content", decode(metaContent));
  fd.append("parentId", decode(metaParentID));
  axios({
    method: "POST",
    url: `${API_ENDPOINT.apiURL}Profile/postComments`,
    data: fd,
  })
    .then(function (response) {
      window.location.assign(`${API_ENDPOINT.redirectURL}${decode(redirectURL)}`);
    })
    .catch(function (err) {
      console.log(err);
    });
};
